<template>
    <v-container>
        <v-card>
        <v-form ref="sendMessegeForm">
        <v-card-title>{{text.sendMessege}}</v-card-title>
        <v-card-text>
            {{text.messege.sendMessegeDescription}}<br>
            <div style="margin-bottom: 1ex;padding-left: 2ch;border: 1px solid;border-radius: 4px;">
                <p>{{ text.templete }}</p>
                <div style="display: flex;">
                    <div style="max-width: 50ch;">
                    <v-select :items="templeteList" @input="templeteSelected" v-model="templeteSelect" ></v-select>
                    </div>
                    <v-btn @click="openSaveTemplete">{{ text.edit }}</v-btn>
                </div>
            </div>
            <v-textarea :label="text.messegeText" :rules="[sendMessege.rule]" outlined :counter="sendMessege.limit" v-model="sendMessege.txt">
            </v-textarea>
        </v-card-text>
        <v-card-actions>
            <div class="d-flex flex-column">
                <div v-show="sended">{{text.messege.sendedMessede}}</div>
                <v-switch v-model="sendMessege.sw" :label="text.messege.traing.sw"></v-switch>
                <v-btn :disabled="sendMessege.sw" @click="sendMessegeExe">{{text.send}}</v-btn>
            </div>
        </v-card-actions>
        </v-form>
    </v-card>
        <v-dialog persistent v-model="saveTempleteDialog.open" max-width="500">
            <v-card>
                <v-card-title>{{ text.templete }}</v-card-title>
                <v-card-text>
                        <p>ID={{ saveTempleteDialog.id }}:</p>
                    <div>
                        <v-text-field v-model="saveTempleteDialog.title" :label="text.messege.templeteTitle"></v-text-field>
                    </div>
                    <v-textarea :label="text.messegeText" outlined :counter="sendMessege.limit" v-model="sendMessege.txt"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="saveTemplete">{{text.save}}</v-btn>
                    <v-btn @click="saveTempleteDialog.open = false">{{text.cancel}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import {apiRequest} from "../lib/api";
    import * as comm from '../common';
    interface Template{name:string,mes:string,id:number}

    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }
    export default Vue.extend({
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            sended:false,
            sendMessege:{
                sw:true,
                txt:"",
                limit:3000,
                rule:(value:string)=> value.length <3000 || text.Text.messege.textLengthOver,
            },
            templeteList:[] as Array<{text:string,value:number}>,
            templeteSelect:null as null|number,
            saveTempleteDialog:{
                open:false,
                title:"",
                id:"",
            }
        }),
        props:{
            mesTemplete:{
                type: Array,
                required: true,
            },
        },
        mounted(){
            this.api = this.$store.state.apiSaver;
        },
        watch:{
            mesTemplete(){
                this.templeteUpdate();
            }
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            async sendMessegeExe(){
                const refForm = this.$refs.sendMessegeForm as vueRefForm;
                if(!refForm.validate() || this.sendMessege.sw){
                    return false;
                }
                this.sendMessege.sw = true;
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const userList = await this.api.apiRequest.request.admin.sendMessege(this.sendMessege.txt);
                    comm.LoadingOverlay(this,false);
                    if(userList.statusCode === 200){
                        this.sended = true;
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(userList.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError,true);
                }
            },
            templeteUpdate(){
                this.templeteList.splice(0);
                for(const t of this.mesTemplete as Array<Template>){
                    this.templeteList.push({
                        "text":`${t.id.toString()}:${t.name}`,
                        "value":t.id,
                    });
                }
            },
            templeteSelected(){
                this.sendMessege.txt = "";
                const selectTemplate = (this.mesTemplete as Array<Template>).find(v=>v.id===this.templeteSelect);
                if(selectTemplate){
                    this.sendMessege.txt = selectTemplate.mes;
                }
            },
            openSaveTemplete(){
                const selectTemplate = (this.mesTemplete as Array<Template>).find(v=>v.id===this.templeteSelect);
                if(selectTemplate){
                    this.saveTempleteDialog.title = selectTemplate.name;
                    this.saveTempleteDialog.id = selectTemplate.id.toString();
                    this.saveTempleteDialog.open = true;
                }
            },
            async saveTemplete(){
                const selectTemplate = (this.mesTemplete as Array<Template>).find(v=>v.id===this.templeteSelect);
                if(selectTemplate){
                    if(this.api && this.api.connection && this.api.apiRequest){
                        comm.LoadingOverlay(this,true);
                        const updateRes = await this.api.apiRequest.request.admin.putMesTepmlete({"id":selectTemplate.id,"name":this.saveTempleteDialog.title,"text":this.sendMessege.txt});
                        comm.LoadingOverlay(this,false);
                        if(updateRes.statusCode === 200){
                            comm.SuccessMessege(this,this.text.messege.dbSccess);
                            this.saveTempleteDialog.open = false;
                            this.$emit("parentCall","tepmleteUpdate");
                        }else if(updateRes.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError,true);
                        }
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError,true);
                }
            }
        },
    });
</script>
